import { Component, Input, input } from '@angular/core';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'app-cycle-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cycle-status.component.html',
  styleUrl: './cycle-status.component.scss'
})
export class CycleStatusComponent {
    @Input() cyclePhase:  { state: string, day?: string | null, trimester?: string };

    /** 'inline' renders inside the chat column, 'header' renders right-aligned in the desktop header row. */
    @Input() variant: 'inline' | 'header' = 'inline';
}
